module.exports = require("@pb/kit-component-group/");